import React, { useEffect } from 'react';

import type AnalyticsWebClient from '@atlassiansox/analytics-web-client';

import { cx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import type { AnalyticsAttributes } from '@atlassian/analytics-bridge';

interface PreviewPanelBodyProps {
	analyticsAttributes?: AnalyticsAttributes;
	analyticsClient?: AnalyticsWebClient | undefined | null;
	children: React.ReactNode;
	panelType?: string;
	parentProduct?: string;
	styles?: Record<string, any>;
}

export const PreviewPanelBody = ({
	children,
	analyticsClient,
	parentProduct,
	panelType,
	analyticsAttributes,
	styles,
}: PreviewPanelBodyProps): React.JSX.Element => {
	useEffect(() => {
		if (analyticsClient) {
			analyticsClient.sendTrackEvent({
				action: 'viewed',
				actionSubject: 'preview-panel',
				actionSubjectId: 'preview-panel-view',
				source: 'preview-panel',
				attributes: {
					parentProduct,
					panelType,
					...(fg('add_capacity_tab_to_the_board_horizontal_nav') ? analyticsAttributes : {}),
				},
			});
			// https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
			// Fires at most once per hour, per product.
			// Requires tenantInfo and userInfo to be set
			analyticsClient?.startUIViewedEvent();
		}
	}, [analyticsClient, parentProduct, panelType, analyticsAttributes]);

	// ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
	// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
	return <Box xcss={cx(!!styles && styles)}>{children}</Box>;
};
